import * as React from "react";
import { useEffect, useRef } from "react";
import { useNomaContext } from "../../Contexts/MapContext";

const privacyUrl = "https://www.lvm.lv/privatuma-politika";

export const PrivacySection = () => {
    const { registerFeature } = useNomaContext();
    const containerRef = useRef<HTMLDivElement>();

    const actionWord = registerFeature.get("LAYERID") === "1" ? "apbūves" : "nomas";

    useEffect(() => {
        const captcha = document.getElementsByClassName("grecaptcha-badge")[0].cloneNode(true);
        containerRef.current && containerRef.current.append(captcha);
    }, []);

    return (
        <div className="privacy-section">
            <p>Nosūtot pieteikumu, Jūs iesniedzat savus personas datus.</p>
            <p>Pārzinis: AS “Latvijas valsts meži”.</p>
            <p>Kontaktinformācija: Vaiņodes iela 1, Rīga, LV-1004, e-pasts: lvm@lvm.lv, tālrunis 67610015.</p>
            <p>
                {`Datu apstrādes mērķis: reģistrēt un apstrādāt pretendenta pieteikumu ${actionWord} tiesību piešķiršanai.`}
            </p>
            <p>
                Papildus informācija par datu apstrādi pieejama &nbsp;
                <a className="url" href={privacyUrl} rel="noopener noreferrer" target="_blank">
                    Privātuma politikā.
                </a>
            </p>
            <div className="captcha-container" ref={containerRef}></div>
        </div>
    );
};
